import {
    PROFILE_DETAILS_DATA
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case PROFILE_DETAILS_DATA:
            return {
                ...state,
                SUBMIT_loading: false,
                profileDetails: action.profileDetails,
            }
        default:
            return state
    }
}